<template>
  <v-main class="pa-4" fluid>
    <v-row >

      <v-snackbar v-model="alerta.activo" vertical top right :color="alerta.color" > 
        <strong> {{alerta.texto}} </strong>
        <template v-slot:action="{ attrs }">
          <v-btn dark text @click="alerta.activo = false" v-bind="attrs"> Cerrar </v-btn>
        </template>
      </v-snackbar>
      
      <v-col cols="12">
        <v-card class="shadowCard" :height="pantallaMaquilador">

          <v-card-title primary-title>
	  		    <span class="text-h5 font-weight-bold"> Pedidos Pendientes </span>
	  		    <v-spacer></v-spacer>
	  		    <v-btn color="secondary" dark  class="mr-2" @click="initialize()">
              <span class="hidden-sm-and-down">Actualizar </span> <v-icon>mdi-refresh</v-icon>
            </v-btn>
	  		  </v-card-title>

          <v-row class="pa-3">
           
            <v-col cols="12" sm="4" md="3" lg="2"  >
              <v-dialog ref="fecha" v-model="fechamodal" :return-value.sync="fecha" persistent width="290px">
                <template v-slot:activator="{ on }">
                  <v-text-field
                    v-model="fecha" label="Fecha" append-icon="event" readonly v-on="on"
                    outlined dense hide-details color="primary"
                  ></v-text-field>
                </template>
                <v-date-picker v-model="fecha" locale="es-es" color="secondary"  scrollable>
                  <v-spacer></v-spacer>
                  <v-btn text  color="error" @click="fechamodal = false">Cancelar</v-btn>
                  <v-btn dark  color="secondary" @click="$refs.fecha.save(fecha)">OK</v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>

            <v-container style="height: 300px;" v-if="Loading">
              <loading/>
            </v-container>

            <v-col cols="12" v-if="!pendientes.length && !Loading">
              <v-alert icon="mdi-shield-lock-outline" prominent text type="error" class="overline">
                No hay registros para mostrar actualmente, Recargue la información o espere a que haya pedidos.
              </v-alert>
            </v-col>

            <v-col cols="12" v-else>
              <v-row>
                <v-col
                  cols="12" sm="6" md="4" xl="3"
                  class="pa-4"
                  v-for="(item , i) in pendientes" :key="i"
                >
                  <v-card height="auto"  class="shadowCard ">
                    <v-list color="black" dark subheader two-line>
                      <v-list-item class="py-0">
                        <v-list-item-content>
                          <v-list-item-title class="text-h6"> # Pedido  {{ item.idpedidos }}</v-list-item-title>
                          <v-list-item-subtitle ></v-list-item-subtitle>
                        </v-list-item-content>
                        <!-- <v-list-item-content class="text-right">
                          <v-list-item-title class="font-weight-black " >
                            <span class="subtitle-1">Total</span> <br>
                            <span class="text-h6">$ {{ item.total }}</span>
                          </v-list-item-title>
                        </v-list-item-content> -->
                      </v-list-item>
                    </v-list>

                    <v-simple-table  fixed-header height="auto">
                      <template v-slot:default>
                        <thead>
                          <tr>
                            <th class="text-left"> Artículo </th>
                            <th class="text-left"> Cantidad </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="item2 in item.articulos" :key="item2.idproducto">
                          <!-- <tr v-for="(item2 , j) in 20" :key="j"> -->
                            <td class="subtitle-1">{{ item2.nomart }}</td>
                            <td class="subtitle-1">{{ item2.cantidad }}</td>
                          </tr>
                        </tbody>
                      </template>
                    </v-simple-table>
                  </v-card>
                  
                  <div class="my-1"></div>
                  <v-footer class="pa-0" flat>
                    
                    <v-btn
                      v-if="item.proceso == 4"
                      color="primary"
                      class="text-center elevation-8"
                      block dark 
                      @click="modalRecoleccion = true; parametros = item"
                    > Recolectar
                    </v-btn>

                    <v-btn
                      v-if="item.proceso == 5"
                      color="success"
                      class="text-center elevation-8"
                      block dark 
                      :to="{name:'control_entrega', params:{item: item}  }"
                      > Entregar
                      <!-- @click="modalRecoleccion = true; parametros = item" -->
                    </v-btn>
                  
                  </v-footer>
                </v-col>
              </v-row>
            </v-col>

          </v-row>
       

        </v-card>
      </v-col>

      <v-dialog v-model="modalRecoleccion" persistent width="500">
        <v-card>
          <v-card-title class="subtitle-1 font-weight-black " style="word-break:normal;">
            <span > ¿ESTÁS SEGURO DE ESTAR RECOLECTANDO EL PEDIDO CORRECTO   ? </span>
          </v-card-title>
          <v-divider class="my-0 py-3" ></v-divider>
          <v-card-subtitle align="center" class="red--text font-weight-bold "> 
            UNA VEZ PROCESADA NO SE PODRÁ RESTABLECER
          </v-card-subtitle>
          <v-divider class="my-0 py-2 " ></v-divider>

          <v-card-text class="py-0">
            <v-textarea
              filled
              v-model="obs"
              label="Agrega un comentario"	
              rows="3"  
              placeholder="Escribe aquí tus comentarios..." >
            ></v-textarea>
          </v-card-text>

          <v-card-actions >
            <v-btn color="error" dark @click="modalRecoleccion=false" >  NO, Cancelar </v-btn>
            <v-spacer/>
            <v-btn color="primary" text @click="cambiarEstatusRepartidor()" >  SÍ, Recolectar </v-btn>
          </v-card-actions>
        </v-card>
      </v-dialog>  
      
      <v-dialog v-model="modalAsignarRepartidor" width="500">
        <v-card class="pa-4">
          <controlRepartidor 
          :parametros="parametros"
          @modal="modalAsignarRepartidor = $event;" 
          @init="finalizarProceso()" />
        </v-card>
      </v-dialog>
        
      <overlay v-if="overlay"/>

    </v-row>
  </v-main>
</template>

<script>
  import Vue from 'vue'
  import  metodos from '@/mixins/metodos.js';
	import {mapGetters, mapActions} from 'vuex'
  import loading from '@/components/loading.vue'
  import overlay from '@/components/overlay.vue'
  import controlRepartidor from '@/views/administrativo/Maquiladores/control_repartidor.vue'
  
  export default {
    mixins:[metodos],
    components: {
      loading,
      overlay,
			controlRepartidor,
		},
    data: () => ({
      pedidos:[],
      contador: 0,

      alerta: { activo: false, texto:'', color:'error' },
      Loading: false,
      overlay :false,
      
      modalAsignarRepartidor: false, 
      modalRecoleccion:false,
      proceso: 5,
      parametros: {},
      obs: '',

      pendientes: [],
      porEntregar:[],
      entregados:[],

      fecha: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
			fechamodal:false,
    }),

    computed: {
      ...mapGetters('Login', ['getdatosUsuario']),
    },

    created () {
      this.initialize();
    },

    watch: {
      fecha(){
        this.initialize();
      }
    },

    methods: {
      initialize () {
        this.Loading = true;
        const payload ={
          idrepartidor: this.getdatosUsuario.idusuariosweb,
          fecha : this.fecha
        }
        this.$http.post('obtener.pedidos.pendientes', payload).then( response =>{
          console.log('response', response.body);
          this.pendientes = response.body
        }).catch( error =>{
          console.log('error', error)
        }).finally(()=>{ 
          this.Loading = false
        })
      },

      validarCambioEstatus(proceso, item){
        this.proceso = proceso;
        this.parametros = item;
        this.modalRecoleccion = true;
      },

      cambiarEstatusRepartidor(){
        this.modalRecoleccion = false;
        this.overlay = true;

        const payload ={
          proceso: this.proceso,
          idseguimiento_pedidos: this.parametros.idseguimiento_pedidos,
          obs: this.obs
        }

        this.$http.post('actualizar.proceso.pedido', payload).then( response =>{
          this.alerta = { activo: true, color:'success', texto: "Pedido iniciado correctamente" };
          this.initialize();
          this.limpiarCampos();
        }).catch( error =>{
          console.log('error', error);
          this.alerta = { activo: true, color:'error', texto: "Ocurrio algun error" };
        }).finally(()=>{ 
          this.overlay = false
        })
      },


      // calculateTimeRemaining() {
      //   const now = new Date();
      //   this.pendientes.forEach((pedido) => {
      //     const asignacionMaquilador = new Date(pedido.asignacion_maquilador);
      //     const tiempoTranscurrido = now - asignacionMaquilador;
      //     const segundosTranscurridos = Math.floor(tiempoTranscurrido / 1000); // Obtener segundos
      //     const minutos = Math.floor(segundosTranscurridos / 60);
      //     const segundos = segundosTranscurridos % 60;
      //     const horas = Math.floor(minutos / 60);
      //     const minutosRestantes = minutos % 60;
      //     let tiempo = '';

      //     if (horas > 0) {
      //       tiempo += `${horas.toString().padStart(2, '0')}:`;
      //     }

      //     tiempo += `${minutosRestantes.toString().padStart(2, '0')}:${segundos.toString().padStart(2, '0')}`;
      //     pedido.tiempo = tiempo;
      //   });
      // },


      limpiarCampos(){
        this.proceso = 1;
        this.parametros = {}
        this.obs = ''
      },


      finalizarProceso(){
        this.modalAsignarRepartidor = false; 
        this.initialize();
      }
    },
  }
</script>

<style scoped>
  .normal{
    text-transform: none;
  }

</style>